import { API_BASE_URL } from '../config/env';
import { getToken, getCurrentWalletAddress } from './request';

let timer: ReturnType<typeof setInterval> | undefined;
let activeWallet = '';
let heartbeatInFlight = false;

const interact = () => {
  activeWallet = getCurrentWalletAddress().toLowerCase();
};

function heartbeat() {
  if (typeof document !== 'undefined' && document.hidden) return;
  if (heartbeatInFlight) return;
  const token = getToken();
  const wallet = getCurrentWalletAddress().toLowerCase();
  if (!token || !wallet || token.startsWith('mock-')) {
    activeWallet = '';
    return;
  }
  // 无交互则不打心跳，避免闲置页每 20s 空刷
  const active = activeWallet === wallet;
  activeWallet = '';
  if (!active) return;
  // Analytics must not refresh authentication, show errors, or delay orders.
  // 8s：进页挤连接时 3s 易超时在 DevTools 显示「已取消」，不挡业务
  heartbeatInFlight = true;
  uni.request({
    url: `${API_BASE_URL}${import.meta.env.DEV ? '' : '/api'}/v1/activity/heartbeat`,
    method: 'POST',
    data: { active: true },
    timeout: 8_000,
    header: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    fail: () => {},
    complete: () => {
      heartbeatInFlight = false;
    },
  });
}

export function startUserActivity() {
  if (timer) return;
  if (typeof document !== 'undefined') {
    document.addEventListener('pointerdown', interact, { passive: true });
    document.addEventListener('keydown', interact, { passive: true });
  }
  // 不立刻打；等用户有交互后再上报
  timer = setInterval(heartbeat, 20_000);
}

export function stopUserActivity() {
  if (timer) clearInterval(timer);
  timer = undefined;
  activeWallet = '';
  if (typeof document !== 'undefined') {
    document.removeEventListener('pointerdown', interact);
    document.removeEventListener('keydown', interact);
  }
}
